import {
  getComponents,
  getGlobalStyles,
  getTypography,
  palettes,
} from "@theatticusapp/atticus-shared-components";
import { createTheme } from "@mui/material/styles";
import { Theme } from "@mui/material/styles";

declare module "@mui/styles/defaultTheme" {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

const defaultTheme = createTheme();

// override theme attributes (temp or not) here
//  SEE EXAMPLES BELOW
// TODO: move to shared
palettes.light.background = {
  default: "#F9FAFE",
};

// TODO: move to shared
const modifiedComponents = getComponents(palettes.light);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
modifiedComponents.MuiDrawer = {
  styleOverrides: {
    paper: {
      boxShadow:
        "0px 8px 10px -5px rgba(116, 135, 164, 0.2), 0px 16px 24px 2px rgba(116, 135, 164, 0.14), 0px 6px 30px 5px rgba(116, 135, 164, 0.12)",
    },
  },
};
modifiedComponents.MuiDialog = {
  styleOverrides: {
    paper: {
      borderRadius: "8px",
      // width: 800,
      // [defaultTheme.breakpoints.down("sm")]: {
      //   width: "80%",
      // },
      // [defaultTheme.breakpoints.down("xs")]: {
      //   width: "90%",
      // },
      [defaultTheme.breakpoints.up("md")]: {
        minWidth: 800,
      },
    },
  },
};

export const lightTheme = createTheme({
  palette: palettes.light,
  typography: getTypography(palettes.light), // modifiedTypography
  components: modifiedComponents, //getComponents(palettes.light), // modifiedComponents
});

export const { styles } = getGlobalStyles(palettes.light);

/*
// EXAMPLE palettes modification
palettes.light.success = {
  light: atticusColors.purple1,
  main: atticusColors.purple2,
};
*/

/*
// EXAMPLE component modification
const modifiedTypography = getTypography(palettes.light);
TODO: create example
*/

/*
// EXAMPLE component modification
const modifiedComponents = getComponents(palettes.light);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
modifiedComponents.MuiButton.styleOverrides.containedSecondary = {
  "&:hover": {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    backgroundColor: palettes.light?.secondary?.light,
    boxShadow: "none",
  },
};
*/
